import { Clock, Star, MapPin, Shield, CheckCircle2 } from 'lucide-react';

const reasons = [
  {
    icon: Clock,
    title: 'Available Every Day',
    description: "We don't take weekends off. Open Monday through Sunday, 8 AM to 8 PM.",
    highlight: '7 Days',
  },
  {
    icon: Star,
    title: 'Highly Rated',
    description: 'Proudly maintaining a 4.6-star reputation for quality workmanship and honest pricing.',
    highlight: '4.6★',
  },
  {
    icon: MapPin,
    title: 'Local Experts',
    description: 'Conveniently located in Portland to dispatch quickly to your residential or commercial electrical needs.',
    highlight: 'Portland',
  },
  {
    icon: Shield,
    title: 'Licensed & Insured',
    description: 'Fully licensed electricians with comprehensive insurance for your peace of mind.',
    highlight: '100%',
  },
];

export const WhyChooseUs = () => {
  return (
    <section id="why-us" className="py-24 bg-zinc-900 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://images.unsplash.com/photo-1628347422534-3cdff90dee42?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt=""
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="overline" data-testid="why-us-overline">Why Fred Joules</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3 tracking-tight" data-testid="why-us-heading">
            Why Choose Us?
          </h2>
          <p className="text-zinc-400 mt-4 max-w-2xl mx-auto text-lg">
            When electrical issues arise, you need a team you can trust to show up, get it done right, and treat you fairly.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={reason.title}
                className="bento-item card-lift p-8 text-center"
                data-testid={`why-us-card-${index}`}
              >
                <div className="w-16 h-16 bg-yellow-400 mx-auto mb-6 flex items-center justify-center">
                  <Icon className="w-8 h-8 text-black" aria-hidden="true" />
                </div>
                <span className="text-3xl font-bold text-yellow-400">{reason.highlight}</span>
                <h3 className="text-xl font-bold text-white mt-2 mb-3">{reason.title}</h3>
                <p className="text-zinc-400 text-sm">{reason.description}</p>
              </div>
            );
          })}
        </div>

        {/* Additional Benefits */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
          {['Free Estimates', 'Upfront Pricing', 'Clean Worksite', 'Warranty Included'].map((benefit, index) => (
            <div key={benefit} className="flex items-center gap-3 p-4 bg-zinc-800/50 border border-white/5">
              <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" aria-hidden="true" />
              <span className="text-sm text-zinc-300">{benefit}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
